module.exports = __webpack_public_path__ + "img/closeline.b40f7082.svg";